import React from 'react';
import { Paper, Typography, Box, LinearProgress, Stack } from '@mui/material';
import { BieMoney } from './BieValue';

type Props = {
  title: string;
  rows?: any[];
  labelKey?: string;
  valueKey?: string;
};

class BreakdownPanel extends React.PureComponent<Props> {
  render() {
    const { title, rows = [], labelKey = 'category', valueKey = 'amount' } = this.props;
    const max = Math.max(...rows.map(r => Math.abs(Number(r[valueKey] || 0))), 1);

    return (
      <Paper elevation={1} sx={{ p: 2, height: '100%' }}>
        <Typography variant="h6" gutterBottom>{title}</Typography>
        <Stack spacing={1.5}>
          {rows.map((r, i) => {
            const value = Number(r[valueKey] || 0);
            return (
              <Box key={`${r[labelKey]}-${i}`}>
                <Box display="flex" justifyContent="space-between" gap={2}>
                  <Typography variant="body2">{r[labelKey]}</Typography>
                  <Typography variant="body2" fontWeight={600}><BieMoney value={value} /></Typography>
                </Box>
                <LinearProgress
                  variant="determinate"
                  value={Math.min(100, Math.abs(value) / max * 100)}
                  sx={{ mt: 0.5, height: 8, borderRadius: 2 }}
                />
              </Box>
            );
          })}
          {rows.length === 0 && (
            <Typography variant="body2" color="text.secondary">No data available</Typography>
          )}
        </Stack>
      </Paper>
    );
  }
}

export default BreakdownPanel;
